import { useEffect, useRef, useMemo } from 'react';
import debounce from 'lodash.debounce';
export default function useDebounce(func, wait, options, deps) {
    if (deps === void 0) { deps = []; }
    var debouncedFnRef = useRef();
    debouncedFnRef.current = useMemo(function () {
        if (debouncedFnRef.current) {
            debouncedFnRef.current.cancel();
        }
        return debounce(func, wait, options);
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, deps);
    useEffect(function () { return function () { return debouncedFnRef.current && debouncedFnRef.current.cancel(); }; }, []);
    return debouncedFnRef.current;
}
//# sourceMappingURL=useDebounce.js.map